import { render, staticRenderFns } from "./CustomerSpecChatsPage.vue?vue&type=template&id=77b5901b&scoped=true&lang=pug&"
import script from "./CustomerSpecChatsPage.vue?vue&type=script&lang=js&"
export * from "./CustomerSpecChatsPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSpecChatsPage.vue?vue&type=style&index=0&id=77b5901b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b5901b",
  null
  
)

export default component.exports